// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../home/tiger/.nvm/versions/node/v12.4.0/lib/node_modules/@ies/eden/node_modules/@ies/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OJ150s4tq57YO_GPpphNv{align-items:center;display:flex}._12TuxKDAbj7j5Wboaufmg4{height:.4rem;width:100%}.nhVugmbxYGjGb2YW_HrTm{margin-top:3.5rem}._3Hv_-WCRUpW20i6kdS-NdH{display:flex;flex-direction:column;align-items:center}._2J9EWu1xM7O8zFpPoz4-k-{width:2.28rem;height:2.28rem;margin-right:.8rem;border-radius:.12rem;background:#e5e5e6}._2V8n0H4femmrm-svCWliF3{height:.32rem;background:#e5e5e6}.ySsqAZtTVwreelnu9IAyg{margin-right:.30rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "OJ150s4tq57YO_GPpphNv",
	"place": "_12TuxKDAbj7j5Wboaufmg4",
	"refresh": "nhVugmbxYGjGb2YW_HrTm",
	"column": "_3Hv_-WCRUpW20i6kdS-NdH",
	"avatar": "_2J9EWu1xM7O8zFpPoz4-k-",
	"section": "_2V8n0H4femmrm-svCWliF3",
	"column1": "ySsqAZtTVwreelnu9IAyg"
};
module.exports = ___CSS_LOADER_EXPORT___;
